import { isOfType } from '../../../../ts-utils';
export const SET_INPUT_RATING = 'SET_INPUT_RATING';
export const setInputRating = (payload) => ({
    type: SET_INPUT_RATING,
    payload,
});
export const isRatingsAction = isOfType([
    SET_INPUT_RATING,
]);
//# sourceMappingURL=ratings-actions.js.map